/**
 * Config declarativo da feature de notificações (inbox client).
 */
export const notificationsConfig = {
  basePath: "/notifications",
  defaultLimit: 20,
  minLimit: 1,
  maxLimit: 100,
  readInboxLimit: 10,
  /** Intervalo do polling GET no NotificationsProvider (5 minutos). */
  pollingIntervalMs: 300_000,
  paths: {
    list: "/notifications",
    markRead: (notificationId) =>
      `/notifications/${encodeURIComponent(notificationId)}/read`,
  },
};

/** Abas do painel de notificações. */
export const NOTIFICATION_INBOX_TABS = {
  pending: "pending",
  essentialRead: "essential-read",
};

export const NOTIFICATION_INBOX_TAB_LABELS = {
  [NOTIFICATION_INBOX_TABS.pending]: "Pendentes",
  [NOTIFICATION_INBOX_TABS.essentialRead]: "Lidas",
};
